export const ORPHAN_TYPES = {
  REPLICA_DATA: 'replica',
  ENGINE_INSTANCE: 'engine-instance',
  REPLICA_INSTANCE: 'replica-instance',
}
